/**
 * Stable worker id for store ↔ configurator round-trips.
 * Preserves UUIDs; never use parseInt on arbitrary strings (e.g. parseInt on UUID prefix is wrong).
 */
export function normalizeWorkerIdString(raw: unknown, index: number): string {
  if (raw === undefined || raw === null) return String(index + 1);
  const s = String(raw).trim();
  return s || String(index + 1);
}
